import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import {
  IGetPutRequest,
  IUseUpdateMutation,
  IUpdateFn,
  ISafetyCaseHazardMitigation,
  ISafetyCaseHazardMitigationUpsert,
} from '../../interfaces'

const getUpdateSafetyCaseHazardMitigationMutationRequest: IGetPutRequest = () => ({
  method: 'put',
  url: `${config.baseUrl}/sms/Mitigations/`,
})

const useUpdateSafetyCaseHazardMitigationMutation: IUseUpdateMutation<
  ISafetyCaseHazardMitigation,
  ISafetyCaseHazardMitigationUpsert
> = (params, options = {}) => {
  const request = useMemo(() => getUpdateSafetyCaseHazardMitigationMutationRequest(params), [params])

  const updateSafetyCaseHazardMitigation: IUpdateFn<ISafetyCaseHazardMitigationUpsert, ISafetyCaseHazardMitigation> =
    useCallback(async data => axios({ ...request, url: request.url + data.id, data }).then(res => res.data), [request])

  const response = useMutation<ISafetyCaseHazardMitigation, Error, ISafetyCaseHazardMitigationUpsert>({
    mutationFn: updateSafetyCaseHazardMitigation,
    ...options,
  })

  return response
}

export default useUpdateSafetyCaseHazardMitigationMutation
